export const ISLOGGED = "ISLOGGED";
export const USER = "USER";
export const TOKEN = "TOKEN";
export const ACCOUNT_CONFIRMED = "ACCOUNT_CONFIRMED";
export const RES_ERROR = "RES_ERROR";
export const RESETPASSWORD = "RESETPASSWORD";
export const GET_CODE_RESET = "GET_CODE_RESET";
